"use client"

import { useState, useEffect } from "react"

import { ChevronDown, ChevronLeft, Minus, Plus } from "lucide-react"
import axios from "axios"
import toast, { Toaster } from 'react-hot-toast';
import {
  createMentorRequest,
  getRequestsByStartup,
  getAllMentors,
  getStartupProfile,
} from "../utils/api"
import { Link, useParams } from "react-router-dom"
import {
  Contact,
  LucideAArrowUp, MessageCircle
} from "lucide-react"
import { MdEmail, MdPhone } from "react-icons/md"
import Skeleton from "react-loading-skeleton"


export default function ViewDetailsPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [fullName, setFullName] = useState("")
  const [email, setEmail] = useState("")
  const [mentors, setMentors] = useState([])
  const [loading, setLoading] = useState(true)
  const [facility, setfacility] = useState([])
  const [defaultImage, setDefaultImage] = useState("")
  const [data, setData] = useState({})
  const id = useParams()['id']

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };



  const toggleSidebar = () => setSidebarOpen((prev) => !prev)

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768
      setIsMobile(mobile)
      if (mobile) setSidebarOpen(false)
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    window.addEventListener("orientationchange", () => {
      setTimeout(handleResize, 100)
    })

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("orientationchange", handleResize)
    }
  }, [])

  const fetchCummaAPI = async () => {
    try {
      const { data } = await axios.get(`https://api.cumma.in/api/service-providers/sharedserviceprovider`)

      const findCompany = data.data.find((each) => each._id == id)
      setDefaultImage(findCompany?.images?.length >= 1 ? findCompany.images[0] : "")
      console.log(findCompany)
      setData(findCompany)


    } catch (error) {
      console.log("Something went wrong")
    }
  }





  useEffect(() => {
    const fetchData = async () => {
      try {
        const startupId = localStorage.getItem("startupId");

        const [profileResRaw, mentorsResRaw, requestsResRaw] = await Promise.all([
          getStartupProfile(startupId),
          getAllMentors(),
          getRequestsByStartup(startupId),
        ]);

        // Normalize profile
        const profile =
          profileResRaw?.data ??
          profileResRaw ?? {};

        // Normalize mentors -> produce an array
        const mentorsData =
          Array.isArray(mentorsResRaw)
            ? mentorsResRaw
            : mentorsResRaw?.data ??
            mentorsResRaw?.data?.data ??
            [];

        // Normalize requests -> produce an array
        const requestsData =
          Array.isArray(requestsResRaw)
            ? requestsResRaw
            : requestsResRaw?.data ??
            requestsResRaw?.data?.data ??
            [];

        // Set profile fields safely
        setFullName(profile.fullName ?? profile.name ?? localStorage.getItem("startupName") ?? "");
        setEmail(profile.email ?? "");

        // Filter only active mentors
        const activeMentors = mentorsData.filter((m) => {
          if (m == null) return false;
          const val = m.isActive;
          return val === true || Number(val) === 1 || String(val) === "1";
        });

        // Extract requested mentor ids
        const requestedMentorIds = (requestsData || []).map((r) => {
          return r?.mentor_id?._id ?? r?.mentor_id ?? r?.mentorId ?? null;
        }).filter(Boolean);

        // Build final mentors list with `requested` boolean
        setMentors(
          activeMentors.map((mentor) => ({
            ...mentor,
            requested: requestedMentorIds.includes(mentor._id),
          }))
        );

      } catch (err) {
        console.error("Error fetching data:", err);
        toast.error("❌ Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchCummaAPI()
  }, []);

  const [numberOfSeats, setNumberOfSeats] = useState(1)
  const [selectedDuration, setSelectedDuration] = useState("monthly")









  return (
    <>
  
      <div className="flex h-screen bg-gradient-to-br ">
        {/* Sidebar */}
       
        {/* Main Section */}
        <div className={`flex flex-col flex-1 transition-all duration-300 min-h-0 ${!isMobile ? "ml-16 sm:ml-18 md:ml-20 lg:ml-20 xl:ml-20" : "ml-0"
          }`}>
          {/* Fixed Header */}

          


          {loading ? <div className="min-h-screen p-6 space-y-6">
            {/* Header Skeleton */}
            <div className="flex items-center gap-2 mb-4">
              <Skeleton circle width={24} height={24} />
              <Skeleton width={80} height={20} />
            </div>

            {/* Image Gallery Skeleton */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              <Skeleton className="sm:col-span-2 h-64 sm:h-80 rounded-lg" />
              <div className="space-y-2">
                <Skeleton height={64} />
                <Skeleton height={64} />
                <Skeleton height={64} />
              </div>
            </div>

            {/* Title & Address Skeleton */}
            <Skeleton height={32} width="60%" className="mb-2" />
            <Skeleton height={20} width="40%" className="mb-1" />
            <Skeleton height={20} width="50%" className="mb-4" />

            {/* Stats Skeleton */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <Skeleton height={80} />
              <Skeleton height={80} />
            </div>

            {/* Hosted By Skeleton */}
            <Skeleton height={80} className="mb-8" />

            {/* Features / About Skeleton */}
            <Skeleton height={24} width="40%" className="mb-2" />
            <Skeleton count={4} height={16} className="mb-1" />

            {/* Sidebar Skeleton */}
            <div className="lg:col-span-1 rounded-lg p-6 space-y-4">
              <Skeleton height={24} width="50%" />
              <Skeleton height={20} />
              <Skeleton height={36} />
              <Skeleton height={36} />
              <Skeleton height={36} />
              <Skeleton height={36} />
              <Skeleton height={40} width="100%" />
              <Skeleton height={40} width="100%" />
            </div>
          </div> : <main className="min-h-screen ">
           
            <header className="border-b border-gray-200">
              <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-4">
                <Link to="/coworkingspaces" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4">
                  <ChevronLeft className="w-5 h-5" />
                  <span>Back</span>
                </Link>
              </div>
            </header>

            {/* Main Content */}
            <div className="w-full px-4 sm:px-6 lg:px-8 py-8 ">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* Left Section - Images and Details */}
                <div className="lg:col-span-2">
                  {/* Image Gallery */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                    {/* Main Image */}
                    <div className="sm:col-span-2">
                      <img
                        src={defaultImage || "/placeholder.svg"}
                        alt={data.serviceName}
                        className="w-full h-64 sm:h-80 object-cover rounded-lg"
                      />
                    </div>

                    {/* Thumbnail */}
                    <div>

                      {data?.images?.length > 0 ? data?.images.slice(0, 3)?.map((each) => (
                        <img
                          src={each || "/placeholder.svg"}
                          alt="Facility thumbnail"
                          className="w-full h-20 sm:h-16  object-cover mt-3 cursor-pointer"
                          onClick={() => setDefaultImage(each)}
                          style={defaultImage == each ? { border: "2px solid black" } : {}}
                        />
                      )) : ""}
                    </div>
                  </div>

                  {/* Title and Address */}
                  <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">{data?.serviceName}</h1>
                  <p className="text-gray-600 mb-1">{data?.address}</p>
                  <p className="text-gray-600 mb-1 flex items-center"> <MdEmail /> {data?.alternateEmailId}</p>
                  <p className="text-gray-600 mb-1 flex items-center"> <MdPhone /> +91 {data?.primaryContactNumber}</p>

                  {/* Stats */}
                  {/* <div className="grid grid-cols-2 gap-4 mb-8">
                    <div className="border border-gray-200 rounded-lg p-4">
                      <p className="text-gray-600 text-sm mb-1">Total Seaters</p>
                      <p className="text-2xl font-bold text-gray-900">{data?.totalseaters}</p>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-4">
                      <p className="text-gray-600 text-sm mb-1">Available Seats</p>
                      <p className="text-2xl font-bold text-gray-900">{data?.availableseats}</p>
                    </div>
                  </div> */}

                  <hr className="mt-3"/>

                  <h3 className="text-3xl font-extrabold text-gray-800 mb-6 px-3 mt-4">
                    All Facilities
                  </h3>

                  {/* Hosted By */}
                  <div>
                    {data?.facilities?.length > 0 ? (
                      data.facilities.map((each, index) => (
                        <div
                          key={index}
                          className="mb-2 border border-gray-200 rounded-xl overflow-hidden shadow-sm py-3"
                        >
                          {/* Accordion Header */}
                          <button
                            onClick={() => toggleAccordion(index)}
                            className="w-full flex items-center justify-between px-5 py-1 bg-gray-50 hover:bg-gray-100 transition-all"
                          >
                            <div className="flex items-center gap-2">
                              <img src={data?.logoUrl} className="w-10 h-7 rounded-full flex-shrink-0" />
                              <p className="font-semibold text-gray-800" style={{textAlign:"justify"}}>
                                {each.details.name}
                              </p>


                            </div>

                            <ChevronDown
                              className={`text-gray-500 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""
                                }`}
                            />
                          </button>

                          {/* Accordion Body */}
                          {openIndex === index && (
                            <div className="px-6 py-4 border-t border-gray-200 bg-white">
                              <p className="text-gray-600 mb-2">{each.details.description}</p>
                              {each?.details?.images?.length > 0 ? (
                                <div className="flex gap-3 mt-4 overflow-x-auto">
                                  {each?.details?.images?.map((img, i) => (
                                    <img
                                      key={i}
                                      src={img}
                                      alt={img.alt || `Facility Image ${i + 1}`}
                                      className="w-40 h-28 object-cover rounded-lg flex-shrink-0 shadow-sm hover:scale-105 transition-transform"
                                    />
                                  ))}
                                </div>
                              ) : (
                                <p className="text-gray-400 text-sm mt-2">No images available</p>
                              )}
                              
                                 
                                
                             

                              {/* Rental Plans */}
                              <div className="flex flex-col gap-3 mt-5">
                                <h2 className="font-medium text-gray-700">Rental Plans</h2>

                                {each?.details?.rentalPlans?.length > 0 ? (
                                  each.details.rentalPlans.map((plan, i) => (
                                    <div
                                      key={i}
                                      className="flex justify-between items-center border border-gray-100 bg-gray-100 rounded-lg px-2 py-2 cursor-pointer hover:bg-gray-200"
                                    >
                                      <div>
                                        <p className="font-semibold text-gray-800">{plan.name}</p>
                                        <p className="text-gray-500 text-sm">{plan.duration}</p>
                                      </div>
                                      <p className="text-black-600 font-bold">₹{plan.price}</p>
                                    </div>
                                  ))
                                ) : (
                                  <p className="text-gray-400 text-sm">No rental plans available</p>
                                )}
                              </div>


                              <div className="flex flex-col gap-3 mt-3">
                                <h2 className="font-medium text-gray-700">Timings</h2>

                                {each?.timings ? (
                                  Object.entries(each.timings).map(([day, value]) => (
                                    <div key={day} className="flex items-center gap-2 justify-between">
                                      <h6 className="font-light text-gray-400 text-sm uppercase">
                                        {day}:
                                      </h6>

                                      {value.isOpen ? (
                                        <p className="text-black text-sm">
                                          {value.openTime} - {value.closeTime}
                                        </p>
                                      ) : (
                                        <p className="text-red-700 text-sm">Closed</p>
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  <p className="text-gray-400 text-sm">No timings available</p>
                                )}


                              </div>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-gray-500 text-sm italic">No facilities available</p>
                    )}
                  </div>

                  {/* About Section */}
                  <section className="mb-8">
                    {/* <h2 className="text-2xl font-bold text-gray-900 mb-4">About this space</h2> */}
                    <p className="text-gray-700 leading-relaxed mb-4"></p>

                    {/* Amenities */}
                    <div className="mt-6">
                      <h3 className="text-3xl font-extrabold text-gray-800 mb-6 px-3">Features</h3>
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 px-3">
                        {data?.features?.map((amenity, index) => (
                          <li
                            key={index}
                            className="inline-block bg-gray-100 cursor-pointer text-black-700 rounded-full px-3 py-3 text-sm font-medium shadow-sm hover:bg-gray-200 transition"
                          >
                            {amenity}
                          </li>
                        ))}
                      </ul>
                    </div>

                  </section>

                </div>

                {/* Right Section - Booking Sidebar */}
                <div className="lg:col-span-1 ">
                  <div className=" rounded-lg p-6 sticky top-8">
                    {/* Pricing Info */}
                    <div className="mb-6 pb-6 border-b border-gray-200">
                      <div className="flex justify-between items-center mb-3">
                        <span className="text-gray-600">Completed Bookings</span>
                        <span className="font-semibold text-gray-900">{data?.completedBookings}</span>
                      </div>
                      <div className="flex justify-between items-center mb-3">
                        <span className="text-gray-600">State</span>
                        <span className="font-semibold text-gray-900">{data?.stateProvince}</span>
                      </div>
                      <div className="flex justify-between items-center mb-3">
                        <span className="text-gray-600">City</span>
                        <span className="font-semibold text-gray-900">{data?.city}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">Service Type</span>
                        <span className="font-semibold text-gray-900">{data?.serviceProviderType}</span>
                      </div>
                    </div>

                    {/* Duration Text */}
                    {/* Auth Buttons */}


                    {/* Booking Duration */}


                    {/* Booking Seat */}


                    {/* Total Price */}


                    {/* Date and Time */}

                  </div>
                </div>
              </div>
            </div>
          </main>
          }


          {/* Scrollable Content */}

        </div>
      </div>


    </>
  )
}